export default __webpack_public_path__ + "static/media/HistoryMobile.a63592b0.png";